// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export const ShippingCountryCountryFragmentDoc = `
    fragment shippingCountryCountry on Country {
  isoCode
  currency
}
    `;
export const ShippingCountryFragmentDoc = `
    fragment shippingCountry on ShippingCountries {
  countries {
    ...shippingCountryCountry
  }
}
    `;
export const PreInitDocument = `
    query preInit {
  shippingCountries {
    ...shippingCountry
  }
}
    ${ShippingCountryFragmentDoc}
${ShippingCountryCountryFragmentDoc}`;

export function usePreInitQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.PreInitQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.PreInitQuery, SchemaTypes.PreInitQueryVariables | undefined>({ query: PreInitDocument, variables: undefined, ...options });
};